import { useSelector } from 'react-redux'
import { Divider, Stack } from '@mui/material'

import {
  selectReasonsForNotCompletedOrders,
  selectTerritories,
  selectTerritory,
} from '@/features/domain/territory'

import { StartEndRoute } from './StartEndRoute/StartEndRoute'
import { DynamicLoadsCfView } from './DynamicLoadsCfView/DynamicLoadsCfView'
import { ReasonsForNotCompletedOrders } from './ReasonsForNotCompletedOrders/ReasonsForNotCompletedOrders'
import { preview } from '@/components/form/preview'
import { DriverActivityHeader } from './DriverActivityHeader'

interface Props {
  onEdit: () => void
}

export function DriverActivityView(props: Props) {
  const { onEdit } = props

  const reasonsForNotCompletedOrders = useSelector(selectReasonsForNotCompletedOrders)

  const territories = useSelector(selectTerritories)
  const territory = useSelector(selectTerritory)

  const singleTerritory = Object.keys(territories).length === 1

  return (
    <>
      <preview.Root
        applyPendingFitMapOnMount={false}
        header={<DriverActivityHeader onEdit={onEdit} />}
        rightBorder={false}
        testId="driver-activity-view"
      >
        <Stack spacing={4}>
          <StartEndRoute
            singleTerritory={singleTerritory}
            startEndRouteActive={territory.mobileAppsTrackingType === 'ORDERSTEPS_AND_BOUND'}
          />
          <Divider />
          <DynamicLoadsCfView territory={territory} hasOnlyOneTerritory={singleTerritory} />
          <Divider />
          <ReasonsForNotCompletedOrders
            territories={territories}
            reasonsForNotCompletedOrders={reasonsForNotCompletedOrders}
          />
        </Stack>
      </preview.Root>
    </>
  )
}
